// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__ervKH","buttons":"Footer_buttons__hRv_g"};